import { gql } from '@apollo/client';
import { genericFields } from './index';

export const agencyItemsFragment = gql`
  fragment agencyItemFields on Item {
    ${genericFields}
    photos(limit: 1) {
      thumbnail
      f460x345
    }
  }
`;
